import type { MenuItemDefinition } from './AppMenuItem.vue'

export const MENU_DEFINITION: MenuItemDefinition[] = [
  {
    label: 'Home',
    icon: 'immi:home',
    to: '/dashboard',
  },
  {
    label: 'Calendario',
    icon: 'immi:calendario',
    children: [
      {
        label: 'Calendario',
        icon: 'pi pi-calendar-plus',
        to: '/calendario/calendario',
        permission: 'CALENDARIO_APPUNTAMENTI_READ',
      },
      {
        label: 'Appuntamenti',
        icon: 'pi pi-list-check',
        to: '/calendario/appuntamenti',
      },
      {
        label: 'Tipologie',
        icon: 'pi pi-list',
        to: '/calendario/tipologie',
        permission: 'CALENDARIO_TIPOLOGIE_READ',
      },
    ],
  },
  {
    label: 'Personale',
    icon: 'immi:operatori',
    children: [
      {
        label: 'Lista Personale',
        icon: 'immi:elenco',
        to: '/personale',
        permission: 'PERSONALE_READ',
      },
      {
        label: 'Personale Presente',
        icon: 'immi:listaPresenze',
        to: '/personale/presenti',
        permission: 'PERSONALE_PRESENTE_READ',
      },
      {
        label: 'Comunicazioni',
        icon: 'immi:message',
        to: '/messaggi',
        permission: 'MESSAGGI_READ',
      },
    ],
  },
  {
    label: 'Ospiti',
    icon: 'immi:ospiti',
    children: [],
  },
  {
    label: 'Strutture',
    icon: 'immi:gestioneCentri',
    to: '/strutture',
    requiresAziendaLotti: true,
  },
  {
    label: 'Assistenza',
    icon: 'immi:assistenza',
    children: [
      { label: 'I miei ticket',   icon: 'pi pi-ticket',    to: '/ticket',          permission: 'TICKET_VIEW_OWN' },
      { label: 'Nuovo ticket',    icon: 'pi pi-plus',       to: '/ticket/nuovo',    permission: 'TICKET_CREATE' },
      { label: 'Coda Helpdesk',   icon: 'pi pi-inbox',      to: '/helpdesk',        permission: 'TICKET_OPERATOR' },
      { label: 'Config Helpdesk', icon: 'pi pi-sliders-h',  to: '/helpdesk/config', permission: 'TICKET_ADMIN' },
    ],
  },
  {
    label: 'Amministrazione',
    icon: 'immi:amministrazione',
    permission: 'AUTH_ROLE_ADMIN',
    children: [
      {
        label: 'Ruoli',
        icon: 'pi pi-id-card',
        to: '/admin/roles',
        superAdminOnly: true,   // fase ibrida: gestiti da Seam
      },
      {
        label: 'Permessi Utente',
        icon: 'pi pi-user-edit',
        to: '/admin/user-permissions',
        // visibilità decisa dal backend (MenuService con gate passpartout admin.permessiUtente)
      },
      {
        label: 'Diagnostica',
        icon: 'pi pi-search',
        to: '/admin/diagnostics',
      },
      {
        label: 'Guide',
        icon: 'pi pi-book',
        to: '/admin/guide',
        permission: 'GUIDA_EDIT',
      },
      {
        label: 'Comunicazioni',
        icon: 'pi pi-megaphone',
        to: '/admin/sse-debug',
        permission: 'AUTH_ROLE_ADMIN',
      },
      {
        label: 'Notifiche Email',
        icon: 'pi pi-envelope',
        to: '/admin/notifiche-log',
        permission: 'AUTH_ROLE_ADMIN',
      },
      {
        label: 'Gestione Menu',
        icon: 'pi pi-sitemap',
        to: '/admin/menu',
        permission: 'AUTH_ROLE_ADMIN',
      },
      {
        label: 'Plugin',
        icon: 'pi pi-plug',
        to: '/admin/plugins',
        permission: 'ADMIN_PLUGINS',
      },
      {
        label: 'Configurazione Pagine',
        icon: 'pi pi-sliders-h',
        to: '/admin/pagine-config',
        permission: 'ADMIN_PLUGINS',
      },
      {
        label: 'Scheduler',
        icon: 'pi pi-clock',
        to: '/admin/schedulers',
        permission: 'ADMIN_SCHEDULER',
      },
      {
        label: 'Feedback Chatbot',
        icon: 'pi pi-chart-bar',
        to: '/admin/chatbot-feedback',
        permission: 'ADMIN_SCHEDULER',
      },
      {
        label: 'Log Permessi',
        icon: 'pi pi-history',
        to: '/admin/permission-log',
        permission: 'AUTH_ROLE_ADMIN',
      },
    ],
  },
]
